export const getCompanyByID = /* GraphQL */ `
  query getComp($id: ID!) {
  getCompany(id: $id){
    id
    name
    portrait
    address { street city country }
    contact { web phone email }
    endOfFiscalYear
    ipo
    freeFloat
    industry
    industryId
    shareholders { name percent }
    ceo  { name email phone salutation }
    irc { name email phone salutation }
    supervisoryBoard { name email phone salutation }
    managementBoard { name email phone salutation }
    events { items { event_id date type name url }}
    sectorLevel0 { id name }
  }
}
`
